export const GET_ALL_EMAIL_TEMPLATE_DATA = 'GET_ALL_EMAIL_TEMPLATE_DATA'
export const GET_EMAIL_TEMPLATE_BY_ID = 'GET_EMAIL_TEMPLATE_BY_ID'
export const UPDATE_EMAIL = 'UPDATE_EMAIL'
export const RESET_EMAIL_WAS_CREATED_OR_UPDATED = 'RESET_EMAIL_WAS_CREATED_OR_UPDATED'
